import { Reducer } from "redux";
import { Action, ActionType } from "../../../actions";
import { ResultsData } from "../../../state/SearchManager/ResultsData";
import { DEFAULT_LIMIT } from '../../../state/SearchManager/FormData';


const updateResultsData: Reducer<ResultsData> = (state: ResultsData = new ResultsData(), action: Action<ActionType, ResultsData>) => {
  switch (action.type) {
    case ActionType.SEARCH_MANAGER_DIAGNOSTICS_EXCEPTIONS_DATA_FETCHED:
      let fetchedRuleList = action.data,
        showMore = false
      if (fetchedRuleList.length > DEFAULT_LIMIT) {
        fetchedRuleList = fetchedRuleList.slice(0, DEFAULT_LIMIT);
        showMore = true;
      }
      return { ...state, ruleList: fetchedRuleList, showMore };
    case ActionType.SEARCH_MANAGER_DIAGNOSTICS_EXCEPTIONS_DATA_UPDATED:
      let updatedRuleList = action.data,
        showMoreUpdated = false
      if (updatedRuleList.length > DEFAULT_LIMIT) {
        updatedRuleList = updatedRuleList.slice(0, DEFAULT_LIMIT);
        showMoreUpdated = true;
      }
      return { ...state, ruleList: [...state.ruleList, ...updatedRuleList], showMore: showMoreUpdated };
    case ActionType.SEARCH_MANAGER_DIAGNOSTICS_EXCEPTIONS_DATA_REFRESHED:
      let showMoreRefreshed = false
      if (action.data.length - 1 > state.ruleList.length) {
        showMoreRefreshed = true;
      }
      return { ...state, ruleList: action.data, showMore: showMoreRefreshed };
    case ActionType.SEARCH_MANAGER_DIAGNOSTICS_EXCEPTIONS_DATA_CLEARED:
      return { ...state, ruleList: [], showMore: false };
    default:
      return state;
  }
};

export default updateResultsData;
